// **  Initial State
const initialState = {
  mainFolders: [],
  folderSelected: {},
  stimulusSelected: {},
  stimulusToCompare: [],
  analysisDashboard: localStorage.getItem('analysisDashboard') ? JSON.parse(localStorage.getItem('analysisDashboard')) : { folder: [], stimulus: [] },
  activeFolder: null,
  flag: { id: 0 },
  subcards: {},
  metrics: [],
  metricsSelected: ["1", "2", "3", "13", "14"],
  benchmark: [],
  benchmarkSelected: [],
  update_Folder: { id_folder: null },
  update_details: { update: null }
}

const imageModuleReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'HANDLE_STIMULUS':
      return { ...state, stimulusSelected: { ...action.value } }
    case 'HANDLE_FOLDER':
      return { ...state, folderSelected: { ...action.value } }
    case 'HANDLE_MAIN_FOLDERS':
      return { ...state, mainFolders: [...action.value] }
    case 'HANDLE_STIMULUS_TO_COMPARE':
      return { ...state, stimulusToCompare: [...action.value] }
    case 'HANDLE_ANALYSIS_DASHBOARD':
      return { ...state, analysisDashboard: { ...action.value } }
    case 'HANDLE_ACTIVE_FOLDER':
      return { ...state, activeFolder: { ...action.value } }
    case 'HANDLE_FLAG':
      return { ...state, flag: { ...action.value } }
    case 'HANDLE_SUBCARDS':
      return { ...state, subcards: { ...action.value } }
    case 'HANDLE_METRICS':
      return { ...state, metrics: [...action.value] }
    case 'HANDLE_METRICS_SELECTED':
      return { ...state, metricsSelected: [...action.value] }
    case 'HANDLE_BENCHMARK':
      return { ...state, benchmark: [...action.value]}
    case 'HANDLE_BENCHMARK_SELECTED':
      return { ...state, benchmarkSelected: [...action.value]}
    case 'HANDLE_UPDATE_FOLDER':
      return { ...state, update_Folder: {...action.value}}
    case 'HANDLE_UPDATE_DETAILS':
      return { ...state, update_details: {...action.value}}
    case 'LOGOUT':
      return { ...state, ...initialState }
    default:
      return state
  }
}

export default imageModuleReducer
